import { Component, Injectable, ViewChild, OnInit, OnDestroy, ElementRef, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private translate: TranslateService) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return this.translate.instant('weekdays.' + [weekday - 1]);
  }
  getMonthShortName(month: number): string {
    return this.translate.instant('months.' + [month - 1]);
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}

@Component({
  selector: 'app-date-picker-future-ext',
  templateUrl: './date-picker-future-ext.component.html',
  styleUrls: ['./date-picker-future-ext.component.scss'],
  providers: [{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provider
})

export class DatePickerFutureExtComponent implements OnInit, OnDestroy {

  @ViewChild('d') d;
  @Input() parentFormControl: FormControl;
  @Input() placeholder = '';
  @Input() maxFull: boolean;
  @Input() fromToday = false;
  @Input() disabled = false;

  private subscription;
  private date = new Date();

  get minDate() {
    if (this.fromToday) {
      return { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() };
    }

    return { year: this.date.getFullYear() - 200, month: this.date.getMonth() + 1, day: this.date.getDate() };
  }

  constructor(private eRef: ElementRef) { }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'click').subscribe((event: KeyboardEvent) => {
      if (!this.eRef.nativeElement.contains(event.target)) {
        this.d.close();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/date-picker-future-ext/date-picker-future-ext.component.ts